import styled from "styled-components"
import Modal from "~app/Modal"
import colors from "~constants/colors"

interface ConfirmationModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  message: string
  bookingNumber?: string
  title?: string
  confirmLabel?: string
  cancelLabel?: string
  isLoading?: boolean
  // Opt-in: render the "Enter to confirm · Esc to cancel" hint. Off by default
  // because those keys are only wired where the caller handles them.
  shortcutHint?: boolean
}

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  message,
  bookingNumber,
  title,
  confirmLabel = "Confirm",
  cancelLabel,
  isLoading = false,
  shortcutHint = false,
}: ConfirmationModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      maxWidth="440px"
      buttonLabel={confirmLabel}
      cancelLabel={cancelLabel}
      cancelButton={true}
      isButtonLoading={isLoading}
      isButtonDisabled={isLoading}
      onRequestClose={onClose}
      onRequestConfirm={onConfirm}
    >
      {title && <Title>{title}</Title>}
      <Message>{message}</Message>
      {bookingNumber && (
        <Message>
          <strong>Booking Number:</strong> {bookingNumber}
        </Message>
      )}
      {shortcutHint && (
        <Hint>
          <Kbd>Enter</Kbd> to {confirmLabel.toLowerCase()} · <Kbd>Esc</Kbd> to
          cancel
        </Hint>
      )}
    </Modal>
  )
}

const Title = styled.h3`
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 600;
  color: ${colors.blue1};
`

const Message = styled.p`
  margin: 0 0 4px;
  font-size: 14px;
  line-height: 1.5;
  color: ${colors.blue3};
`

const Hint = styled.div`
  margin: 16px 0 12px;
  font-size: 12px;
  color: ${colors.gray6};
`

const Kbd = styled.kbd`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  font-family: inherit;
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  color: ${colors.gray6};
  background: ${colors.gray1};
  border: 1px solid ${colors.gray2};
  border-radius: 3px;
`

export default ConfirmationModal
